import { gql } from '@apollo/client';

export const SAVE_CONTENT_TYPE_GROUP = gql`
  mutation saveContentType($input: ContentTypeInput!) {
    saveContentType(input: $input) {
      commandId
      correlationId
    }
  }
`;

export const SAVE_CONTENT_TYPE_X_METADATA = gql`
  mutation saveContentTypeXMetadata($input: ContentTypeXMetadataInput!) {
    saveContentTypeXMetadata(input: $input) {
      commandId
      correlationId
    }
  }
`;

export const DELETE_CONTENT_TYPE_X_METADATA = gql`
  mutation deleteContentTypeXMetadata($id: Int!) {
    deleteContentTypeXMetadata(id: $id) {
      commandId
      correlationId
    }
  }
`;

export const SAVE_CONTENT_TYPE_X_USER_GROUPS = gql`
  mutation saveContentTypeXUserGroups($input: [ContentTypeXUserGroupModel]) {
    saveContentTypeXUserGroups(input: $input) {
      commandId
      correlationId
    }
  }
`;
